const mutationTypes = {
  ATTEMPTING_LOGIN: 'ATTEMPTING_LOGIN',
  LOGIN: 'LOGIN',
  LOGIN_FAILED: 'LOGIN_FAILED',
  LOGOUT: 'LOGOUT',
  SET_AUTHORITIES: 'FETCHED_AUTHORITIES',
  SET_ANALYSIS_TYPES: 'FETCHED_AUTHORITIES',
  SET_2FA_REQUIRED: 'SET_2FA_REQUIRED',
  PRE_AUTH_USER: 'PRE_AUTH_USER'
}

const actionTypes = {
  LOGIN: 'LOGIN',
  CODE: 'CODE',
  VERIFY_CODE: 'VERIFY_CODE',
  FETCH_AUTHORITIES: 'FETCH_AUTHORITIES',
  FETCH_ANALYSIS_TYPES: 'FETCH_ANALYSIS_TYPES',
}

export { mutationTypes, actionTypes }



// WEBPACK FOOTER //
// ./src/store/modules/SessionTypes.js